import configCommon from "./config.common.json";
import devConfig from "./config.dev.json";
const deployConfig = {
    "api_url": window.location.origin+'/api/',
    "api_auth_url": window.location.origin+'/auth/',
    "max_file_upload": import.meta.env.VUE_APP_MAX_FILE_UPLOAD,
    "chunk_size": import.meta.env.VUE_APP_CHUNK_SIZE,
    "download_rangesize": import.meta.env.VUE_APP_DOWNLOAD_RANGESIZE,
    "defaultLocale": import.meta.env.VUE_APP_DEFAULT_LOCALE,
    "localeFallback": import.meta.env.VUE_APP_LOCALE_FALLBACK,
    "supportedLangues": `${import.meta.env.VUE_APP_SUPPORTED_LANGUES}`.split(','),
    "localizationHeader": import.meta.env.VUE_APP_LOCALIZATION_HEADER,
    "errorMessagesLifetime": import.meta.env.VUE_APP_ERROR_MESSAGES_LIFETIME,
    "successMessagesLifetime": import.meta.env.VUE_APP_SUCCESS_MESSAGES_LIFETIME,
    "declarationModeleHelp": import.meta.env.VUE_APP_DECLARATION_MODELE_HELP,
    "declarationAnalyzeHelp": import.meta.env.VUE_APP_DECLARATION_ANALYZE_HELP,
    "tinyMceApiKey" : import.meta.env.VUE_APP_TINY_MCE_API_KEY
}

const configuration = import.meta.env.MODE === "development" ? {
    ...configCommon,
    ...devConfig
} :
    {
        ...configCommon,
        ...deployConfig
    }

export default configuration;
